<div class="applicant-form-wrapper" [ngClass]="{'with-border': (applicationType && applicationType === 'inquire')}">
  @if (showSpinner) {
    <div class="loading-shaded-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }

  @if (currentApplicant && currentUser) {
    <form class="applicant-form" novalidate (ngSubmit)="submitForm()">
      @if (applicationType && applicationType === 'inquire') {
        <div class="header-block">
          <h2 class="form-header-title">
            INQUIRE ABOUT THIS JOB
            <small class='apply-now-text'>OR <a (click)="goToApplyPage()">APPLY NOW</a></small>
          </h2>
        </div>
      }
      <div class="form-group required">
        <label for="firstNameInput" class='control-label'>First name</label>
        <input id="firstNameInput" type="text" class="form-control" name="first_name" [(ngModel)]="currentUser.first_name" (keyup)="checkForm()" required
          [ngClass]="{'invalid-input': (formChecked && !currentUser.first_name || currentUser.first_name === '' || currentUser.first_name === '-')}">
      </div>

      <div class="form-group required">
        <label for="lastNameInput" class='control-label'>Last name</label>
        <input id="lastNameInput" type="text" class="form-control" name="last_name" [(ngModel)]="currentUser.last_name" (keyup)="checkForm()" required
          [ngClass]="{'invalid-input': (formChecked && !currentUser.last_name || currentUser.last_name === '' || currentUser.last_name === '-')}">
      </div>

      <div class="form-group required">
        <label for="phoneInput" class='control-label'>Phone Number</label>
        <input id="phoneInput" type="tel" class="form-control" phoneValidatorMask name="phone" [(ngModel)]="currentUser.phone" (keyup)="checkForm()" required
          [ngClass]="{'invalid-input': (formChecked && !currentUser.phone || currentUser.phone === '')}">
      </div>

      <div class="form-group required">
        <label for="emailInput" class='control-label'>Email</label>
        <input id="emailInput" type="email" class="form-control" name="email" [(ngModel)]="currentUser.email" (keyup)="checkForm()" required
          [ngClass]="{'invalid-input': (formChecked && !currentUser.email || currentUser.email === '')}">
      </div>

      <!-- This section is only for Apply Now -->
      @if (applicationType && applicationType === 'apply') {
        <div class="apply-to-job-fields">
          <div class="form-group required">
            <label for="addressInput" class='control-label'>Address</label>
            <input id="addressInput" type="text" class="form-control" name="address" [(ngModel)]="currentUser.address" (keyup)="checkForm()" required
              [ngClass]="{'invalid-input': (formChecked && !currentUser.address || currentUser.address === '')}">
          </div>
          <div class="form-group required">
            <label for="cityInput" class='control-label'>City</label>
            <input id="cityInput" type="text" class="form-control" name="city" [(ngModel)]="currentUser.city" (keyup)="checkForm()" required
              [ngClass]="{'invalid-input': (formChecked && !currentUser.city || currentUser.city === '')}">
          </div>
          <div class="form-group required">
            <label class='control-label'>State</label>
            <select class="form-select form-select-lg mb-3 form-control" aria-label=".form-select-md example" name="state" [(ngModel)]="currentUser.state" required
              [ngClass]="{'invalid-input': (formChecked && !currentUser.state || currentUser.state === '')}">
              @for (state of statesOptions; track state) {
                <option [value]="state.abbr"><span>{{state.full_name}}</span></option>
              }
            </select>
          </div>
        </div>
      }
      <!-- End Apply Now only -->
      <div class="form-group required">
        <label for="zipInput" class='control-label'>Zip Code</label>
        <input id="zipInput" class="form-control" [mask]="zipMask" pattern="\d{5}" name="zip" [(ngModel)]="currentUser.zip" (keyup)="checkForm()" required
          [ngClass]="{'invalid-input': (formChecked && !currentUser.zip || currentUser.zip === '')}">
      </div>

      <div class="form-group" [ngClass]="{'required': (applicationType && applicationType === 'apply')}">
        <label class='control-label'>Upload Resume <span>(Optional)</span></label>
        <div class="upload-zone" (click)="addFiles()">
          <div class="upload-zone-content">
            @if (fileName && fileName !== '') {
              <span class="upload-icon">&#10003;</span>
              <span class="file-item">{{ fileName }}</span>
            } @else {
              <span class="upload-icon">&#8679;</span>
              <p class="upload-hint">Click to browse for a file</p>
            }
          </div>
          <div class="upload-actions">
            @if (showMyResumeButton) {
              <button type="button" mat-flat-button class="my-resumes-btn" (click)="$event.stopPropagation(); selectUserResume()">My Resumes</button>
            }
            <button type="button" mat-flat-button class="add-files-btn" (click)="$event.stopPropagation(); addFiles()">Browse</button>
          </div>
        </div>
        <input type="file" #file style="display: none" (change)="onFilesAdded()" />
        @if ((applicationType && applicationType === 'apply') && (formChecked && !filesAdded)) {
          <div class="like-mat-error">
            This is a required field
          </div>
        }
      </div>

      <!-- <div *ngIf="userPassedIn" class="form-group">
      <label class='control-label'>Upload Resume <span>(Optional)</span></label>
      <button type="button" mat-flat-button color="primary" class="add-files-btn" (click)="selectUserResume()">My Resumes</button>
    </div> -->

    <div class="form-group">
      <label for="commentsInput" class='control-label'>Comments</label>
      <textarea id="commentsInput" class="form-control" name="comments" [(ngModel)]="currentApplicant.comments" rows="4"></textarea>
    </div>

    <div class="form-group consent-block">
      <h4 class="consent-title">Data and Communication Acknowledgement</h4>
      <div class="opt-in-checkboxes-row">
        <mat-checkbox class="optCommunications-checkbox" color="primary" [(ngModel)]="optIntoSms" name="optSms">Opt in for SMS Communication</mat-checkbox>
        <mat-checkbox class="optCommunications-checkbox" color="primary" [(ngModel)]="optIntoEmailPhone" name="optEmailPhone">Opt in for Email and Phone Calls</mat-checkbox>
      </div>
      <p class="optCommunications-description">
        By checking the box you consent to receive SMS communications from EDU Healthcare regarding job opportunities and related services (including marketing messages) at 
        the provided number. Msg & Data rates may apply. Msg frequency varies. Reply STOP to opt out and HELP for HELP. Read more in our <a routerLink="/privacy-policy">Terms and Privacy Policy</a>.
      </p>
    </div>
    
    <div class="reCaptcha-wrapper">
      <re-captcha
        (resolved)="resolved($event)"
        (error)="errored($event)"
        [siteKey]="siteKey"
      ></re-captcha>
    </div>
    <div class="applicant-btn-group" role="group" aria-label="submit from" [ngClass]="{'button-right': (applicationType && applicationType === 'apply')}">
      <button type="submit" class="btn btn-primary submit-btn" [disabled]="showSpinner || (!optIntoSms && !optIntoEmailPhone)">{{ applicationType }} now</button>
      <!-- <button type="button" mat-raised-button color="default" class="backBtn" (click)="goBack()">Cancel</button> -->
    </div>
  </form>
}
</div>